import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  makeStyles,
  IconButton,
  Tooltip,
  Button,
  Grid,
  Typography,
  DialogTitle,
  Divider,
  TextField,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Badge,
  InputAdornment

} from "@material-ui/core";
import { withStyles } from '@material-ui/core/styles';

import ListAltIcon from "@material-ui/icons/ListAlt";
import CloseIcon from "@material-ui/icons/Close";
import UpdateIcon from "@material-ui/icons/Update";
import LaunchIcon from "@material-ui/icons/Launch";

import { useDispatch, useSelector } from "react-redux";
import { getItem, getItems, updateItem, getSuppliers, getUOMs, getCategories, getMovesByItem } from "../../../actions/inventoryAction";
import ItemQuantModal from "./ItemQuantModal";
import ItemMoveModal from "./ItemMoveModal";

import Feedback from "../../../utils/Feedback";
import clsx from "clsx";

const StyledBadge = withStyles((theme) => ({
    badge: {
      right: 3,
      top: 3,
      padding: '0 4px',
    },
  }))(Badge);

const useStyles = makeStyles((theme) => ({
  dialogContent: {
    padding: theme.spacing(6),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2),
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },

  title: {
    fontSize: 13,
  },
  time: {
    // marginLeft: "auto",
    marginTop: 10,

    // width: 120,
    width: "fit-content",
    height: 40,
    padding: theme.spacing(1),
    // textAlign: "center",
    margin: "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  icon: {
    marginRight: 5,
  },
  btn: {
    padding: theme.spacing(1.5),
    marginTop: 30,
    marginBottom: 30,
    width: 300,
    [theme.breakpoints.down("sm")]: {
        width: "50%",
      },
    [theme.breakpoints.down("xs")]: {
    width: "100%",
    }
  },
  btnLink: {
    padding: theme.spacing(1.5),
    marginTop: 30,
    color: theme.palette.primary.main,
    width: 300,
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  dialog: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      height: "100%",
    },
  },
  formControl: {
    minWidth: 420,
    [theme.breakpoints.down("sm")]: {
      minWidth: 350,
    },
    [theme.breakpoints.down("xs")]: {
        minWidth: "100%",
    },
  },
  formcontrol2: {
    textAlign: "left",
    minWidth: 420,
    [theme.breakpoints.down("sm")]: {
      minWidth: 350,
    },
    [theme.breakpoints.down("xs")]: {
        minWidth: "100%",
    }

  },
paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
},
paper2:{
    padding: theme.spacing(1),
    textAlign: "center",
    width: "fit-content",
    height: 50,
    display: "flex",
    justifyContent: "center",
    margin: "auto",
},
[theme.breakpoints.down("sm")]: {
    width: "100%",
},
[theme.breakpoints.down("xs")]: {
    minWidth: "100%",
},

fab: {
    right: theme.spacing(-1),
},
status:{
    width: "fit-content",
    height: 50,
    padding:10,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "auto",
    marginRight: -30
  },

  divider: {
    height: 40,
    margin: 4,
    width: 2,
  },
  statusDarkGreen: {
    borderColor: "#4caf50",
  },
  statusGreen: {
    borderColor: "#1de9b6",
  },
  statusYellow: {
    borderColor: "#fbc02d",
  },
  statusOrange: {
    borderColor: "#ff9800",
  },
  statusRed: {
    borderColor: "#ef5350",
  },

}));

const INIT_STATE = {
    name: "",
    category: "",
    uom: undefined,
    cost: 0,
    stockLevel: 0,
    reorderLevel: 0,
    supplier: undefined,
    width: "",
    dimension: "",
    thickness: "",
    heatNo: "",
    comment: "",
    error: null,
    success: false,
    loading: false,
};

const EditItemModal = ({ openEdit, handleCloseEdit, id }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [state, setState] = useState(INIT_STATE);
  const [feed, setFeed] = React.useState({
    loading: false,
    open: false,
    message: "",
    success: false,
  });

  const { item, suppliers, uoms, categories, moveByItem, error, loading } = useSelector((state) => state.inventory);
  const [openAllQuant, setOpenAllQuant] = useState(false);
  const [openAllMove, setOpenAllMove] = useState(false);
  const [getId, setGetId] = useState("");
  const { profile} = useSelector((state) => state.users);

  useEffect(() => {
    dispatch(getItems());
    dispatch(getSuppliers());
    dispatch(getUOMs());
    dispatch(getCategories());
    }, [dispatch]);

  useEffect(() => {
    const abortController = new AbortController();
    if (error && error !== null) {
      setFeed((prev) => ({
        loading: false,
        open: true,
        message: error,
        success: false,
      }));
    }
    return () => {
      abortController.abort();
    };
  }, [error]);

  useEffect(() => {
    if (id){
        dispatch(getItem(id));
        dispatch(getMovesByItem(id))
    }
    
  }, [dispatch, id]);

  useEffect(() => {
    setState((prev) => ({
      ...prev,
        name: item && item.name,
        category: item && item.category?._id,
        uom: item && item.uom?._id,
        cost: item && item.cost,
        stockLevel: item && item.stockLevel,
        reorderLevel: item && item.reorderLevel,
        supplier: item && item.supplier?._id,
        width: item && item.width,
        dimension: item && item.dimension,
        thickness: item && item.thickness,
        heatNo: item && item.heatNo,
        comment: item && item.comment,


    }));
  }, [item]);

  const handleChange = (e) => {
    e.persist();
    setState((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  

  const handleSubmit = (e) => {
    e.preventDefault();
    let data = {
        name: state.name,
        category: state.category,
        uom: state.uom,
        cost: state.cost,
        stockLevel: state.stockLevel,
        reorderLevel: state.reorderLevel,
        supplier: state.supplier,
        width: state.width,
        dimension: state.dimension,
        thickness: state.thickness,
        heatNo: state.heatNo,
        comment: state.comment,
        id,
    };
    dispatch(updateItem(data));
    setTimeout(() => {
      handleCloseEdit();
     
      dispatch(getItems());
      setFeed((prev) => ({
        loading: false,
        open: true,
        message: "Item Updated Successfully.",
        success: true,
      }));
    }, 1500);
  };


  const handleCloseFeed = () => {
    setFeed((prevState) => ({ ...prevState, open: false }));
  };

  const handleOpenAllQuant = (id) => {
    setGetId(id);
    setOpenAllQuant(true);
  };

  const handleCloseAllQuant = () => {
    setOpenAllQuant(false);
  };

  const handleOpenAllMove = (id) => {
    setGetId(id);
    setOpenAllMove(true);
  };

  const handleCloseAllMove = () => {
    setOpenAllMove(false);
  };

  const isValid = () => !state.name

  let isAdminGuard = profile
    ? (profile &&
        profile.role && profile.role.map((role) => role.name).includes("admin"))
    : false;

    let isInventoryAdmin = profile
    ? (profile &&
        profile.role && profile.role.map((role) => role.name).includes("inventory_admin"))
        : false;

  return (
    <div>
        <ItemMoveModal {...{ openAllMove, handleCloseAllMove, id: getId }} />
        <ItemQuantModal {...{ openAllQuant, handleCloseAllQuant, id: getId }} />
      {feed.success ? (
        <Feedback
          handleCloseFeed={handleCloseFeed}
          open={feed.open}
          severity="success"
          message={feed.message}
        />
      ) : (
        <Feedback
          handleCloseFeed={handleCloseFeed}
          open={feed.open}
          severity="error"
          message={feed.message}
        />
      )}
      <Dialog open={openEdit} onClose={handleCloseEdit} fullWidth maxWidth="md" className={classes.dialog}>
        <DialogTitle>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <Typography variant="overline" className={classes.title}>
                Edit Item
              </Typography>
            </Grid>
            <Grid item>
              <Tooltip arrow title="Close">
                <IconButton onClick={handleCloseEdit}>
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </DialogTitle>
        <Divider />
        <br/>
        <Grid container justifyContent="center" alignItems="center" spacing={3} item xs={12} sm={6}>
            <Grid item xs={3} sm={4}>
                <Paper variant="outlined" className={classes.paper2}>
                
                    <IconButton color="primary" onClick={() => handleOpenAllMove(item._id)}>
                        <StyledBadge badgeContent={moveByItem && moveByItem.length} color="primary" max={99} overlap="rectangular">
                            <Tooltip title="All Item Moves">
                                <ListAltIcon />
                            </Tooltip>
                        </StyledBadge>
                    </IconButton>
                </Paper>
            </Grid>
            <Grid item xs={8} sm={7}>
                <Paper variant="outlined" className={item && item.quantity > 0 ? clsx(classes.status, classes.statusDarkGreen) : 
                    item && item.quantity < 0 ? clsx(classes.status, classes.statusRed) :
                    classes.status}
                >
                    <Typography variant="overline">
                       Quantity In Stock
                    </Typography>
                    <Divider orientation="vertical" className={classes.divider}/>
                    {item && item.quantity} {item && item.uom?.name}
                </Paper>
            </Grid>
            {(isAdminGuard || isInventoryAdmin) ? (
                <Grid item xs={1} sm={1}>
                  <Tooltip title="Update Quantity">
                    <IconButton
                      color="primary"
                      onClick={() => {
                        handleOpenAllQuant(state.item?._id);
                      }}
                    >
                      <UpdateIcon />
                    </IconButton>
                  </Tooltip>
                </Grid>
            ):(
                <Grid item xs={2} sm={2}>
                  <Tooltip title="View Quantity">
                    <IconButton
                      color="primary"
                      onClick={() => {
                        handleOpenAllQuant(state.item?._id);
                      }}
                    >
                      <LaunchIcon />
                    </IconButton>
                  </Tooltip>
                </Grid>
            )}
        </Grid>
        <br/>
        <Divider/>
        <DialogContent className={classes.dialogContent}>
          <form onSubmit={handleSubmit}>
        
            <Grid container justifyContent="center" alignItems="center" spacing={3}>
            <Grid item xs={12} sm={6}>
                <TextField
                  name="name"
                  fullWidth
                  variant="outlined"
                  label="Description/Grade"
                  onChange={handleChange}
                  value={state.name || ""}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6} >
                  <FormControl variant="outlined" className={classes.formcontrol2}>
                    <InputLabel id="demo-simple-select-outlined-label">
                        Item Category
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      fullWidth
                      value={state.category || ""}
                      name="category"
                      onChange={handleChange}
                      required
                    >
                      <MenuItem value={null}>
                        <em>None</em>
                      </MenuItem>
                      {categories &&
                        categories.map((category) => (
                          <MenuItem key={category._id} value={category._id}>
                            {category.name}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>
              <Grid item xs={12} sm={6} >
                  <FormControl variant="outlined" className={classes.formcontrol2}>
                    <InputLabel id="demo-simple-select-outlined-label">
                        Unit of Measure
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      fullWidth
                      value={state.uom || ""}
                      name="uom"
                      onChange={handleChange}
                      required
                    >
                      <MenuItem value={null}>
                        <em>None</em>
                      </MenuItem>
                      {uoms &&
                        uoms.map((uom) => (
                          <MenuItem key={uom._id} value={uom._id}>
                            {uom.name}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                <TextField
                  name="dimension"
                  fullWidth
                  variant="outlined"
                  label="Dimension"
                  onChange={handleChange}
                  value={state.dimension || ""}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  name="thickness"
                  fullWidth
                  variant="outlined"
                  label="Thickness"
                  onChange={handleChange}
                  value={state.thickness || ""}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  name="heatNo"
                  fullWidth
                  variant="outlined"
                  label="Heat Number"
                  onChange={handleChange}
                  value={state.heatNo || ""}
                />
              </Grid>
              <Grid item xs={12} sm={6} >
                <FormControl variant="outlined" className={classes.formcontrol2}>
                  <InputLabel id="demo-simple-select-outlined-label">
                      Supplier
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    fullWidth
                    value={state.supplier || ""}
                    name="supplier"
                    onChange={handleChange}
                  >
                    <MenuItem value={null}>
                      <em>None</em>
                    </MenuItem>
                    {suppliers &&
                      suppliers.map((supplier) => (
                        <MenuItem key={supplier._id} value={supplier._id}>
                          {supplier.name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  name="cost"
                  fullWidth
                  variant="outlined"
                  label="Cost"
                  onChange={handleChange}
                  value={state.cost || ""}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                  }}
                  type="number"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  name="stockLevel"
                  fullWidth
                  variant="outlined"
                  label="Stock Level"
                  onChange={handleChange}
                  value={state.stockLevel || ""}
                  type="number"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  name="reorderLevel"
                  fullWidth
                  variant="outlined"
                  label="Reorder Level"
                  onChange={handleChange}
                  value={state.reorderLevel || ""}
                  type="number"
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                  <TextField
                  name="comment"
                  fullWidth
                  variant="outlined"
                  label="Comment"
                  onChange={handleChange}
                  value={state.comment || ""}
                  />
              </Grid>
                
            </Grid>
            {(isAdminGuard || isInventoryAdmin) && (
                <Typography align='center'>
                <Button
                    color="primary"
                    variant="contained"
                    size="large"
                    type="submit"
                    endIcon={<UpdateIcon />}
                    className={classes.btn}
                    disabled={isValid() || loading}
                >
                    {loading ? "Loading..." : "Update"}
                </Button>
                </Typography>
            )} 
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default EditItemModal;
